import { reaction, runInAction } from 'mobx';
import StorageUtil from '../utils/StorageUtils';

export default class StoreParaSingleton {

    get objetoSave() { return {} };
    constructor() {
        const storage = StorageUtil.getObject(this.nomeStorage);
        if (storage) {
            for (const key in this.objetoSave) {
                runInAction(()=>{
                    this[key] = storage[key];
                });
            }
        }
    }
    reactionSaveStore = reaction(() => this.objetoSave, objeto => this.save(JSON.stringify(objeto)));

    // Nome composto da store utilizado como chave no localStorage
    get nomeStorage() {
        return (this.objetoSave as any).nomeStore;
    }

    save = (json) => {
        if (this.objetoSave) {
            StorageUtil.setItem(this.nomeStorage, json);
        }
    }

    delete() {
        StorageUtil.removeItem(this.nomeStorage)
    }

    setTimeout(funcao) {
        return setTimeout(runInAction(funcao), 1);
    }

    public inicializar(_router?) {
        if (this.objetoSave) {
            const storage = StorageUtil.getObject(this.nomeStorage);
            if (storage) {
                for (const key in this.objetoSave) {
                    runInAction(() => {
                        this[key] = storage[key];
                    });
                }
            }
        }
    }
}
